"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportOfAdvancedGHG = void 0;
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var Tags_1 = require("../Tags");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var ImportOfAdvancedGHG = (function (_super) {
    __extends(ImportOfAdvancedGHG, _super);
    function ImportOfAdvancedGHG() {
        return _super.call(this, {
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.IMPORT_OF_ADVANCED_GHG,
            tags: [Tags_1.Tags.EARTH, Tags_1.Tags.SPACE],
            cost: 9,
            metadata: {
                cardNumber: '167',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) { return b.production(function (pb) { return pb.heat(2); }); }),
                description: 'Increase your heat production 2 steps.',
            },
        }) || this;
    }
    ImportOfAdvancedGHG.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.HEAT, 2);
        return undefined;
    };
    return ImportOfAdvancedGHG;
}(Card_1.Card));
exports.ImportOfAdvancedGHG = ImportOfAdvancedGHG;
